import { InvoicePrintError } from "./invoicePrintUtils";

export interface InvoicePrintErrorToastOptions {
  title?: string;
  duration?: number;
  position?:
    | "top"
    | "bottom"
    | "top-left"
    | "top-right"
    | "bottom-left"
    | "bottom-right";
}

type ToastFunction = (options: {
  title: string;
  description?: string;
  status: "info" | "warning" | "success" | "error";
  duration?: number;
  isClosable?: boolean;
  position?:
    | "top"
    | "bottom"
    | "top-left"
    | "top-right"
    | "bottom-left"
    | "bottom-right";
}) => void;

export const handleInvoicePrintError = (
  error: unknown,
  toast: ToastFunction,
  customOptions?: InvoicePrintErrorToastOptions
): void => {
  const defaultOptions: Required<InvoicePrintErrorToastOptions> = {
    title: "Unable to print invoices",
    duration: 4000,
    position: "top",
  };

  const options = { ...defaultOptions, ...customOptions };

  if (error instanceof InvoicePrintError) {
    const isNoInvoices = error.code === "NO_INVOICES";

    toast({
      title: isNoInvoices
        ? customOptions?.title || "No Garaaz invoices found"
        : options.title,
      description: error.message,
      status: isNoInvoices ? "info" : "error",
      duration: options.duration,
      isClosable: true,
      position: options.position,
    });
  } else {
    const message =
      error instanceof Error
        ? error.message
        : "Failed to open Garaaz invoices. Please try again later.";

    toast({
      title: options.title,
      description: message,
      status: "error",
      duration: options.duration,
      isClosable: true,
      position: options.position,
    });
  }
};

export const showInvoicePrintSuccess = (
  printableCount: number,
  toast: ToastFunction,
  customOptions?: Omit<InvoicePrintErrorToastOptions, "title">
): void => {
  toast({
    title: "Invoices ready for print",
    description: `Opened ${printableCount} Garaaz invoice${
      printableCount === 1 ? "" : "s"
    }.`,
    status: "success",
    duration: customOptions?.duration || 3000,
    isClosable: true,
    position: customOptions?.position || "top",
  });
};
